import type { ReactElement } from 'react';

import type { QueueState } from '@harness/stream-core';

/** Position and estimated wait, honestly, with a way out. */
export function QueueNotice({
  queue,
  live,
  onCancel,
}: {
  queue: QueueState;
  live: boolean;
  onCancel: () => void;
}): ReactElement {
  const minutes = Math.floor(queue.estimatedWaitSeconds / 60);
  const seconds = queue.estimatedWaitSeconds % 60;
  const wait =
    queue.estimatedWaitSeconds === 0
      ? 'starting now'
      : minutes > 0
        ? `about ${String(minutes)}m ${String(seconds)}s`
        : `about ${String(seconds)}s`;

  return (
    <div className="notice notice--hold" role="status" aria-live="polite">
      <span className="notice__title">Queued</span>
      <p>
        Position <span className="mono">{queue.position}</span>, estimated wait{' '}
        <span className="mono">{wait}</span>.
      </p>
      {live && (
        <div>
          <button type="button" className="button" onClick={onCancel}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
